import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./feature/dashboard/dashboard.component').then(c => c.DashboardComponent),
    },
    {
        path: 'sal-register',
        loadComponent: () => import('./feature/sal-register/sal-register.component').then(c => c.SalRegisterComponent),
        data: { type: 'sal' },
    },
    {
        path: 'other',
        loadComponent: () => import('./feature/sal-register/sal-register.component').then(c => c.SalRegisterComponent),
        data: { type: 'sal' },
    },
    {
        path: 'sal-terms-and-conditions',
        loadComponent: () => import('./feature/sal-terms-and-conditions/sal-terms-and-conditions.component').then(c => c.SalTermsAndConditionsComponent),
        data: { type: 'sal' },
    },
    {
        path: 'pfra-register',
        loadComponent: () => import('./feature/pfra-register/pfra-register.component').then(c => c.PfraRegisterComponent),
        data: { type: 'pfra' },
    },
    {
        path: 'pfra-terms-and-conditions',
        loadComponent: () => import('./feature/pfra-terms-and-conditions/pfra-terms-and-conditions.component').then(c => c.PfraTermsAndConditionsComponent),
        data: { type: 'pfra' },
    },
    {
        path: '**',
        redirectTo: ''
    },
];
